<template>
  <div id="version" class="version">
    <div>Copyright©&nbsp;浙江省急救指挥中心版权所有</div>
    <div>&nbsp;技术支持：杭州触梦智能科技有限公司</div>
    <div>
    <a
            class="link-gov"
            href="http://beian.miit.gov.cn/"
            target="_blank"
    >&nbsp;浙ICP备16046486号-1&nbsp;</a
    >
    </div>
  </div>
</template>

<script>
export default {
  name: "Version",
  data() {
    return {
      year: new Date().getFullYear(),
      version: window.$constant.version,
    };
  },
};
</script>

<style scoped>
a,
a:focus,
a:hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}
.version {
  margin-top: 20px;
  text-align: center;
  line-height: 16px;
  width: 100%;
  font-size: 12px;
  color: #ffffff;
  -webkit-text-size-adjust: 100%;
}
</style>
